<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header" v-if="!modal" >Información del Tipo de Artículo</div>
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols= 'labelCols'
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim= "$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-rubro-trabajo
              label="Rubro"
              :nombre="rubroTrabajoNombre"
              :labelCols= 'labelCols'
              :valido="rubroTrabajoValido"
              :lista="rubrosTrabajosList"
              :msjInvalido="rubroTrabajoInvalidoMsj"
              @validate="validate"
              @updated="rubroTrabajoActualizado">
                <!-- <div class="custom-select-add" 
                  @click.prevent="addRubroTrabajo">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </div> -->
            </app-rubro-trabajo>  

            <b-form-group
              label="Descripción"
              label-for="descripcion"
              :label-cols= 'labelCols'
              horizontal>
              <b-form-textarea
                id="descripcion"
                v-model= "$v.descripcion.$model" 
                rows="5"
                max-rows="50"
                :state="descripcionValida"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="descripcionFeedback">
                {{ descripcionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              :label-cols= 'labelCols'
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>

            <!-- <small class="form-text text-muted leyenda-costos">Evite duplicar artículos. No anteponer artículos gramaticales, usar siempre mayúsculas.</small>
            <small class="form-text text-muted leyenda-costos">Utilice descripciones cortas genéricas que sirvan para diferenciar rápidamente los artículos.</small>
            <small class="form-text text-muted leyenda-costos">Evite abreviaciones. Siempre coloque acentos.</small> -->
          </b-form>

          <div slot="footer" v-if="modal">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      v-if= "!modal"
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import RubroTrabajo from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, numeric, maxLength, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'articuloTipo/getField',
  mutationType: 'articuloTipo/updateField',
});

export default {
  name: 'ArticuloTipoABM',
  components: {
    appRubroTrabajo: RubroTrabajo,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    articuloTipoId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',
      rubroTrabajoValido: null,
      rubroTrabajoInvalidoMsj: '',

      rubrosTrabajos: [],
      rubrosTrabajosList: [],
      plantillaRubro: '',

      tableBusy: false,
      labelCols: 2,
      inicializando: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'descripcion',
      'rubroTrabajo',
      'rubroTrabajoNombre',
      'inactivo',
    ])
  },  
  created() {
    let articuloTipoId = 0;

    if (!this.modal) {
      if (this.$route.params){
        if (this.$route.params.id){
          articuloTipoId = this.$route.params.id;
        }
      }
    }

    if (this.modal) {
      if (this.articuloTipoId) {
        if (this.articuloTipoId != 0) {
          articuloTipoId = this.articuloTipoId;
        }
      }
    }

    this.showSpinner();
    this.inicializando = true;
    this.$store.dispatch('articuloTipo/inicializar', articuloTipoId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => {
        this.hideSpinner();
        this.inicializando = false;
      })
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this;

      vm.getArticulosRubros();
    },
    getArticulosRubros() {
      const vm = this;

      this.$store.dispatch('rubrostrabajos/getRubrosArticulosList')
      .then(() => {
          vm.rubrosTrabajos = this.$store.getters['rubrostrabajos/rubrosList']
          vm.rubrosTrabajosList = this.$store.getters['rubrostrabajos/rubrosSelectList']
        })
      .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de rubros.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre del artículo.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 50 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
        
      if (campo == 'descripcion' || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          // if (!this.$v.descripcion.required) {
          //   this.descripcionInvalidaMsj = 'Debe ingresar la descripción del artículo.';
          // } else 
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción solo puede contener hasta 2500 caracteres';
          }
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let rubroTrabajo = null;
      if (this.rubroTrabajoNombre) {
        rubroTrabajo = this.getSelected(this.rubrosTrabajos, this.rubroTrabajoNombre);
      }
      this.$store.dispatch('articuloTipo/setRubroTrabajo', rubroTrabajo);

      let rubroTrabajoError = true;
      if (this.rubroTrabajo) {
        if (this.rubroTrabajo.id) {
          if (this.rubroTrabajo.id != 0) {
            rubroTrabajoError = false;
          }
        }
      }
      if (rubroTrabajoError) {
        save = Boolean(false);
        this.rubroTrabajoValido = false;
        this.rubroTrabajoInvalidoMsj = "Debe seleccionar el rubro correspondiente.";
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('articuloTipo/save')
            .then(()  => {
              if (!this.modal) {
                this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light');
              } else {
                this.$emit('updateArticuloTipo', 
                  this.$store.getters['articuloTipo/articuloTipo']);
              }
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      } 
    },
    goBack() {
      if (!this.modal) {
        this.$router.go(-1);
      } else {
        this.$emit('closeArticuloTipo');
      }
    },
    goList() {
      this.$router.push({ name: "ArticulosTipos" });
    },
    rubroTrabajoActualizado(rubroTrabajoNombre) {
      if (!this.inicializando) {
        this.rubroTrabajoNombre = rubroTrabajoNombre;

        let rubroTrabajo = null;
        if (this.rubroTrabajoNombre) {
          rubroTrabajo = this.getSelected(this.rubrosTrabajos, this.rubroTrabajoNombre);
        }
        this.$store.dispatch('articuloTipo/setRubroTrabajo', rubroTrabajo);

        if (this.rubroTrabajo) {
          /* Si el rubro tiene una plantilla definida y el articulo no tiene aun una descripción, actualizamos a partir de la plantilla */
          if (this.descripcion.trim() == '') {
            this.descripcion = rubroTrabajo.plantillaArticulos.trim();
          } else {
            this.plantillaRubro = rubroTrabajo.plantillaArticulos.trim();
            
            this.showModalConfirm('El rubro tiene una plantilla asociada. ¿Desea reemplazar la descripción con la plantilla del rubro?', 
                  this.actualizarDescripcionPlantilla, 'Si', null, 'No')
          }

          this.rubroTrabajoValido = null;
          this.rubroTrabajoInvalidoMsj = '';
        }
      }
    },
    actualizarDescripcionPlantilla() {
      if (!this.inicializando) {
        this.descripcion = this.plantillaRubro.trim();
      }
    }
  },
  watch: {
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
    descripcion: {
      // required,
      maxLength: maxLength(2500)
    },
  },  
}
</script>

<style>
</style>
